import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setActivities = activities => {
	activities.data = activities.data.map(function(el) {
		el.start = new Date(el.start);
		el.end = new Date(el.end);
		return el;
	});

	return {
		type: ActionTypes.LOAD_ACTIVITIES,
		activities: activities.data
	};
};

export const loadActivities = date => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/calendar/")
			.then(response => {
				dispatch(setActivities(response.data));
			})
			.catch(error => {});
	};
};

export const saveActivities = activity => {
	return dispatch => {
		axios
			.post("https://getupstudio.co/solanasapi/calendar/", activity)
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};

export const updateActivities = activity => {
	return dispatch => {
		axios
			.patch("https://getupstudio.co/solanasapi/calendar/", activity)
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};

export const deleteActivity = activity => {
	return dispatch => {
		axios
			.delete("https://getupstudio.co/solanasapi/calendar/", {
				params: { id: String(activity.id) }
			})
			.then(response => {
				dispatch(loadActivities(new Date()));
			})
			.catch(error => {});
	};
};
